module.exports = __webpack_public_path__ + "static/img/casino-contents.494125f.jpg";